import { ChevronForwardIc } from '@dsch/dd-icons';

import * as Styled from './Divider.styled';
import { ThemeTypes } from '../../../../../types/Theme.namespace';

const Divider = (props: { color: ThemeTypes.Colors }) => {
  const { color } = props;

  return (
    <Styled.ForwardArrowContainer color={color}>
      <ChevronForwardIc width="16" height="16" aria-hidden="true" />
    </Styled.ForwardArrowContainer>
  );
};

export { Divider };
